import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import useTranslation from '../../../../hooks/useTranslations';
import { setNews } from '../../../../redux/modules/appSlice';
import { selectNewsByIdWithObjects } from '../../../../redux/modules/data/newsSlice';
import ContentWrapper from '../../layouts/partials/ContentWrapper';
import SidebarWrapper from '../../layouts/partials/SidebarWrapper';
import PrivateLayout from '../../layouts/PrivateLayout';
import NewsListRow from './partials/NewsListRow';

const NewsDetail = () => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const { newsId } = useParams();
	const news = useSelector((state) => selectNewsByIdWithObjects(state, newsId));

	useEffect(() => {
		if (newsId && news) {
			dispatch(setNews({ news }));
		}
		return () => {
			dispatch(setNews({ news: null }));
		};
	}, [newsId, news, dispatch]);

	if (!news) {
		return (<Redirect to="/news" />);
	}

	const breadcrumb = [
		{ route: 'news', translationKey: 'news_button' },
		{ route: `news/${news.id}`, translationKey: news.title },
	];
	return (
		<PrivateLayout customTree={breadcrumb}>
			<SidebarWrapper title={t('news_headline')} customTree={breadcrumb} />
			<ContentWrapper classes="px-0 sm:px-5 max-w-table pt-4 sm:pt-8">
				<NewsListRow key={news.id} news={news} isDetail />
			</ContentWrapper>
		</PrivateLayout>
	);
};

export default NewsDetail;
